import { Component, ReactNode, VideoHTMLAttributes } from "react";
import classNames from "classnames";

import styles from "./styles/video.module.scss";
import { undefOrNull } from "../../../utils/booleanUtils";

interface IVideoProps extends VideoHTMLAttributes<HTMLVideoElement> {
  mediaUrl: string;
  imageUrl?: string;
  isBackground?: boolean;
  backgroundType: "cover" | "contain";
  height?: string;
  width?: string;
  description?: string;
  containerClassName?: string;
  children?: ReactNode;
}

interface IVideoState {
  autoPlay?: boolean;
}

export default class Video extends Component<IVideoProps, IVideoState> {
  static defaultProps = {
    height: "100%",
    width: "100%",
    isBackground: false,
  };

  constructor(props: IVideoProps) {
    super(props);

    this.state = {
      autoPlay: props.autoPlay,
    };
  }

  componentDidMount() {
    // https://thenewcode.com/777/Create-Fullscreen-HTML5-Page-Background-Video
    // this is an accessibility thing.  Always override our preferences if a person wants reduced motion.
    if (window.matchMedia("(prefers-reduced-motion)").matches) {
      this.setState({
        autoPlay: false,
      });
    }
  }

  render() {
    const {
      mediaUrl,
      imageUrl,
      backgroundType,
      height,
      width,
      description,
      isBackground,
      containerClassName: videoContainerClassName,
      ...restProps
    } = this.props;

    const containerClassName = classNames({
      [styles.container]: true,
      [videoContainerClassName ?? ""]: videoContainerClassName,
    });

    const videoClassName = classNames({
      [styles.cover]: backgroundType === "cover",
      [styles.contain]: backgroundType === "contain",
    });

    let doLoop = this.props.loop,
      doMuted = this.props.muted,
      doAutoPlay = this.state.autoPlay;

    if (isBackground === true) {
      doLoop = undefOrNull(this.props.loop) ? true : this.props.loop;
      doMuted = undefOrNull(this.props.muted) ? true : this.props.muted;
      doAutoPlay = undefOrNull(this.state.autoPlay)
        ? true
        : this.state.autoPlay;
    }

    return (
      <div
        role="presentation"
        className={containerClassName}
        style={{ height, width }}
        aria-label={description}
      >
        <video
          key={mediaUrl}
          preload={"metadata"}
          loop={doLoop}
          muted={doMuted}
          autoPlay={doAutoPlay}
          playsInline={doAutoPlay}
          poster={imageUrl}
          className={videoClassName}
          {...restProps}
        >
          <source src={mediaUrl} />
        </video>
        {this.props.children}
      </div>
    );
  }
}
